module.exports = __webpack_public_path__ + "static/new-logo-desktop-2c007bde28fb2c0137739a840ab3e3ed.png";